import { render, staticRenderFns } from "./customerNotificationConfiguration.vue?vue&type=template&id=2bd6f010&scoped=true&"
import script from "./customerNotificationConfiguration.vue?vue&type=script&lang=js&"
export * from "./customerNotificationConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./customerNotificationConfiguration.vue?vue&type=style&index=0&id=2bd6f010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6f010",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd6f010')) {
      api.createRecord('2bd6f010', component.options)
    } else {
      api.reload('2bd6f010', component.options)
    }
    module.hot.accept("./customerNotificationConfiguration.vue?vue&type=template&id=2bd6f010&scoped=true&", function () {
      api.rerender('2bd6f010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/customerNotificationConfiguration.vue"
export default component.exports